// toast.service.ts
import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { addIcons } from 'ionicons';
import { alertCircleOutline, checkmarkCircleOutline, informationCircleOutline, warningOutline, close } from 'ionicons/icons';
import { Capacitor } from '@capacitor/core';

type ToastType = 'success' | 'error' | 'alert' | 'warning' | 'info';

@Injectable({ providedIn: 'root' })
export class ToastService {
  // anti-spam: 1 toast cada 1200ms
  private lastToastAt = 0;
  private minGapMs = 1200;
  private static iconsRegistered = false;

  constructor(private toastController: ToastController) {
    if (!ToastService.iconsRegistered) {
      addIcons({
      alertCircleOutline,
      checkmarkCircleOutline,
      informationCircleOutline,
      warningOutline,
      close,
      });
      ToastService.iconsRegistered = true;
    }
  }

  async presentToast(type: ToastType, title: string = '', message = '', position: 'top' | 'bottom' = 'top', duration: number = 6000): Promise<void> {
    const now = Date.now();
    if (now - this.lastToastAt < this.minGapMs) return;
    this.lastToastAt = now;

    const config = this.getConfig(type);

    const toast = await this.toastController.create({
      mode: 'ios',
      cssClass: `ta-toast ta-toast--${type} responsive-toast`,
      position: position,
      duration: duration,
      header: title ? title : config.header,
      message: message,
      icon: config.icon,
      buttons: [
        {
          icon: 'close',
          role: 'cancel',
          side: 'end'
        }
      ]
    });

    await toast.present();
  }

  private getConfig(type: ToastType): {
    header: string;
    icon?: string;
    cssClass?: string;
    dismissible: boolean;
  } {
    const map: Record<ToastType, any> = {
      success: { header: '¡OK!', icon: 'checkmark-circle-outline', dismissible: true },
      error: { header: '¡ERROR!', icon: 'alert-circle-outline', dismissible: true },
      alert: { header: '¡ALERTA!', icon: 'alert-circle-outline', dismissible: false },
      info: { header: '¡INFO!', icon: 'information-circle-outline', dismissible: true },
      warning: { header: '¡AVISO!', icon: 'alert-circle-outline', dismissible: true },
    };
    return map[type];
  }
}
